<template>
  <div class="animated fadeIn">
    <DateModal
      modalID="financial_reports"
      :fetchData="downloadCustom"
      :dateFrom="dateFrom"
      :dateTo="dateTo"
      @date-picker-modal-emit="onDatePickerModalEmit"
    ></DateModal>
    <b-row>
      <b-col lg="9">
        <b-card class="reports">
          <div
            slot="header"
            style="display:flex; justify-content: space-between;"
          >
            <HeaderTitle title="Annual Reports"></HeaderTitle>
          </div>
          <b-row>
            <b-col
              v-for="report in annualReportList"
              :key="report.id"
              lg="4"
              style="display:flex; justify-content:center"
            >
              <CustomButton
                @triggerDownload="
                  n => download(n, report.url, report.params, report.fileName)
                "
                :loading="isLoading"
                :name="report.name"
                :type="report.type"
                :icon="report.icon"
              >
              </CustomButton>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col lg="3">
        <b-card class="reports">
          <div
            slot="header"
            style="display:flex; justify-content: space-between;"
          >
            <HeaderTitle title="Custom Report"></HeaderTitle>
          </div>
          <b-row>
            <b-col lg="12" style="display:flex; justify-content:center">
              <CustomButton
                @triggerDownload="modalDateEvent()"
                :loading="isLoading"
                name="Custom report"
                type="custom"
                icon="fa fa-file-excel-o"
              >
              </CustomButton>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import CustomButton from "../../../components/shared/CustomButton.vue";
import DateModal from "../../../components/shared/DateModal.vue";
import HeaderTitle from "../../../components/shared/HeaderTitle.vue";
import LoadingCard from "../../../components/shared/LoadingCard.vue";
import { isUserLoggedIn, from, to } from "../../../utils/Utils";
import router from "../../../router";

export default {
  name: "FinancialReports",
  components: {
    Datepicker,
    router,
    DateModal,
    HeaderTitle,
    LoadingCard,
    CustomButton
  },
  data() {
    return {
      from: from,
      to: to,
      annualReportList: [
        {
          id: 1,
          type: "2020",
          url: "api/reports/fin2018.php",
          name: "Report For 2020",
          fileName: "FinancialReport_2019",
          params: false,
          icon: "fa fa-file-excel-o"
        },
        {
          id: 2,
          type: "2021",
          url: "api/reports/fin2020.php",
          name: "Report for 2021",
          fileName: "FinancialReport_2021",
          params: false,
          icon: "fa fa-file-excel-o"
        },
        {
          id: 3,
          type: "2022",
          url: "api/reports/fin2021.php",
          name: "Report for 2022",
          fileName: "FinancialReport_2022.xlsx",
          params: false,
          icon: "fa fa-file-excel-o"
        }
      ],
      isLoading: { loading: false, type: "" },
      locationsIds: "",
      modalDate: false,
      dateFrom: "",
      dateTo: ""
    };
  },
  methods: {
    downloadCustom() {
      this.download(
        "custom",
        "api/reports/Portal_PBRS_Fin_custom.php",
        true,
        "FinancialReport_Custom"
      );
    },
    onDatePickerModalEmit(changedDateFrom, changedDateTo) {
      this.dateFrom = changedDateFrom;
      this.dateTo = changedDateTo;
    },
    download(type, url, parameters, fileName) {
      this.isLoading = { loading: true, type: type };
      let params = parameters
        ? {
            date_from: this.dateFrom,
            date_to: this.dateTo
          }
        : {};

      this.$http
        .get(url, {
          params,
          responseType: "blob"
        })
        .then(
          res => {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", fileName + ".xlsx");
            document.body.appendChild(link);
            link.click();
            this.isLoading = { loading: false, type: "" };
          },
          err => {
            this.isLoading = { loading: false, type: "" };
            console.log(err);
          }
        );
    },
    modalDateEvent() {
      this.$bvModal.show("financial_reports");
    }
  },
  mounted() {
    isUserLoggedIn(router);
    this.locationsIds = localStorage.getItem("locations");
  }
};
</script>

<style>
.vdp-datepicker__calendar {
  position: absolute !important;
  z-index: 100;
  background: #3a4149 !important;
  width: 300px;
  border: 1px solid #ccc;
}
.form-control:disabled,
.form-control[readonly] {
  background-color: #515b65 !important;
  opacity: 1 !important;
}
</style>
